import { createContext } from "react";
import { PageActionsPayload } from "./types";

export type PagetActionsContextType = {
	executePageAction: (actionName: string, input: PageActionsPayload, onComplete?: () => void) => void;
};

const PagetActionsContext = createContext<PagetActionsContextType>({ executePageAction: (actionName: string, input: PageActionsPayload, onComplete?: () => void) => {} });

export default PagetActionsContext;
